var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"drawer",staticClass:"drawer left-side",class:{
  isClosed: _vm.isClosed,
  isOpened: !_vm.isClosed,
  isMobile: _vm.isMobile,
  'transition-generic': !_vm.isMoving
},style:({
  left: _vm.position.left,
  width: _vm.width,
  'padding-right': (_vm.padding+'px'),
  'margin-right': (-_vm.padding+'px')
}),on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onMousedown($event)}}},[_c('div',{staticClass:"drawer-opener touch-only mobile-only fixed-left"}),_c('div',{ref:"backdrop",staticClass:"drawer-backdrop fullscreen",on:{"click":_vm.backdropClick}}),_c('div',{ref:"content",staticClass:"drawer-content left-side",style:({
      right: (_vm.padding+'px')
    })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }